import { AxiosResponse } from 'axios'
import { Action } from 'redux'
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  select,
  SelectEffect,
  takeEvery,
} from 'redux-saga/effects'
import actionCreators from '../../actions/fetchAllPhaseItems'
import { PhaseItemsActions } from '../../actions/fetchAllPhaseItems/PhaseItemsActions'
import { fetchPhaseItems } from '../../actions/getAssignments/fetchPhaseItems'
import { loadJsonApiEntities } from '../../actions/loadJsonApiEntities'
import addViewToStore from '../../actions/views/addViewToStore'
import {
  PhaseItemFetchParams,
  PhaseItemsResponsePayload,
} from '../../actions/workflow/types'

type FetchPhaseItems = (
  params: PhaseItemFetchParams
) => Promise<AxiosResponse<PhaseItemsResponsePayload>>

export const _fetchPhaseItems: FetchPhaseItems = (params) =>
  fetchPhaseItems(params)

type Yield =
  | CallEffect<AxiosResponse<PhaseItemsResponsePayload> | null>
  | SelectEffect
  | PutEffect
type Return = void
type Next = AxiosResponse<PhaseItemsResponsePayload> | null

type Payload = {
  view: string
  viewKey?: string
  params: PhaseItemFetchParams
}

export interface ActionWithPayload extends Action {
  payload: Payload
}

export function* fetchAllPhaseItems(
  action: ActionWithPayload
): Generator<Yield, Return, Next> {
  try {
    const view = yield select(
      (state) =>
        state.entityDataByView &&
        action.payload.view &&
        state.entityDataByView[action.payload.view]
    )

    if (view === undefined) {
      yield put(addViewToStore({ view: action.payload.view }))
    }

    const phaseItems = yield call(_fetchPhaseItems, action.payload.params)

    if (phaseItems !== null) {
      yield put(
        loadJsonApiEntities({
          ...phaseItems.data,
          view: action.payload.view,
          entityType: 'phase_item',
          ...(action.payload.viewKey && { viewKey: action.payload.viewKey }),
        })
      )
    }

    yield put(
      actionCreators.fetchPhaseItemsSuccess({ view: action.payload.view })
    )
  } catch (error) {
    console.error(error)

    yield put(
      actionCreators.fetchPhaseItemsError({
        error: error as Error,
        view: action.payload.view,
      })
    )
  }
}

export function* fetchAllPhaseItemsSaga(): Generator<ForkEffect, void, void> {
  yield takeEvery(
    PhaseItemsActions.FETCH_ALL_PHASE_ITEMS_REQUEST,
    fetchAllPhaseItems
  )
}

export default [fetchAllPhaseItemsSaga]
